import { Component,ChangeDetectorRef , OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { SportService } from '../services/sport.service';

@Component({
  selector: 'app-baccarat',
  templateUrl: './baccarat.component.html',
  styleUrls: ['./baccarat.component.scss']
})
export class BaccaratComponent implements OnInit {
  iUrl: any;
  gameList:any
  providerCode:any
  currentPath: string = '';
  previousPath: string = '';
  constructor(private cdr: ChangeDetectorRef,public route: ActivatedRoute,private sport: SportService,private router: Router,) 
  {
    this.providerCode = this.route.snapshot.paramMap.get('gameProvide'); 
     // Listen to route parameter changes
     this.route.params.subscribe((params) => {
      const newPath = params['gameProvide']; // Adjust based on your route parameter key
     
      this.cdr.markForCheck();
      if (this.currentPath !== newPath) {
        this.previousPath = this.currentPath; // Store the previous value
        this.currentPath = newPath; 
        this.gotoexchangeGame(newPath)
      }
      
    });
   }

  ngOnInit(): void {
    
  }
  gotoexchangeGame(cardData) {
    let data = {
      "providerCode":cardData
    }
    
    this.sport.getWCOGameList(data).subscribe((res) => {
      
      if(res.status == true){
       this.gameList=res.data
        // this.iUrl = res.launchUrl;
        // localStorage.setItem('casino',this.iUrl)
        // this.router.navigate(['casino-detail'])
      }
    })
  }
}
